export default "__VITE_ASSET__0567951e__"